define('app/views/yadisa_product_modal_view',['app/setup','app/views/modal_view'], function(takhfifan) {

  takhfifan.YadisaProductModalView = Backbone.View.extend({

    events: {
      'click .modal-trigger': 'showModal'
    },

    initialize: function (options) {
      this.modalContainer = $('.yadisa-deal-details-modal');
      takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
        this.modalContainer.hide();
      }, this);
    },
    
    showModal: function (e) {
      var $el = $(e.target);
      takhfifan.eventHub.trigger('modal:showModalWithContent',
        {
          triggerElement:$el,
          elementToOperateContent: $($el.data("modalContent")).html(),
          fadeTimeIn:400,
          elementToOperate:this.modalContainer
        });
    }
  })
});
